// GET_DISCOVERY_PROVINCES
export const GET_DISCOVERY_PROVINCES = 'GET_DISCOVERY_PROVINCES';
export const GET_DISCOVERY_PROVINCES_SUCCESS = 'GET_DISCOVERY_PROVINCES_SUCCESS';
export const GET_DISCOVERY_PROVINCES_FAILED = 'GET_DISCOVERY_PROVINCES_FAILED';
export const CLEANUP_DISCOVERY_PROVINCES = 'CLEANUP_DISCOVERY_PROVINCES';

// GET_DISCOVERY_PROVINCE_DETAILS
export const GET_DISCOVERY_PROVINCE_DETAILS = 'GET_DISCOVERY_PROVINCE_DETAILS';
export const GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS = 'GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS';
export const GET_DISCOVERY_PROVINCE_DETAILS_FAILED = 'GET_DISCOVERY_PROVINCE_DETAILS_FAILED';
export const CLEANUP_DISCOVER_PROVINCE_DETAILS = 'CLEANUP_DISCOVER_PROVINCE_DETAILS';

// GET_PROVINCES_NAME
export const GET_PROVINCES_NAME = 'GET_PROVINCES_NAME';
export const GET_PROVINCES_NAME_SUCCESS = 'GET_PROVINCES_NAME_SUCCESS';
export const GET_PROVINCES_NAME_FAILED = 'GET_PROVINCES_NAME_FAILED';
export const CLEANUP_PROVINCES_NAME = 'CLEANUP_PROVINCES_NAME';
